/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { Form, Dimmer } from '@mairistem/composants';

import type { ParametresGeneraux } from '@/types';
import { useHubeeStore } from '@/zustand';
import HubeeStatusMessage from '@/components/Hubee/HubeeStatusMessage';

import TabParametre from '../TabParametre';

const HUBEE_PROD_HOSTNAME = 'recensement-citoyen-obligatoire.jvsonline.fr';
const HUBEE_PROD_API_URL = 'https://api.hubee.numerique.gouv.fr';
const HUBEE_PROD_API_VERSION = 'v1';
const HUBEE_PROD_TOKEN_URL =
  'https://auth.hubee.numerique.gouv.fr/oauth2/token';

const isHubeeProdHost =
  typeof window !== 'undefined' &&
  window.location.hostname === HUBEE_PROD_HOSTNAME;

interface TabHubeeProps {
  parametres: ParametresGeneraux;
  onChange: (
    e: React.SyntheticEvent,
    data: {
      name: string;
      value: string;
      checked: boolean;
    },
  ) => void;
}

const TabHubee = (props: TabHubeeProps) => {
  const { parametres, onChange } = props;
  const hubeeStatus = useHubeeStore((state) => state.hubeeStatus);

  const {
    apiHubeeLiaisonActive,
    apiHubeeUrl,
    apiHubeeVersion,
    apiHubeeToken,
    apiHubeeLogin,
    apiHubeeMdp,
  } = parametres || {};

  return (
    <TabParametre title="INFORMATIONS DE CONNEXION">
      <div style={{ position: 'relative' }}>
        <Form.Group style={{ flexDirection: 'column', alignItems: 'flex-end' }}>
          <Form.Checkbox
            label="Liaison active"
            data-testid="hubee-tab-liaison-active-checkbox"
            name="apiHubeeLiaisonActive"
            checked={apiHubeeLiaisonActive}
            onChange={onChange}
          />
        </Form.Group>
        <Form.Group>
          <Form.Input
            width={11}
            disabled={isHubeeProdHost || !apiHubeeLiaisonActive}
            name="apiHubeeUrl"
            data-testid="hubee-tab-api-url"
            label="Accès API (URL)"
            value={isHubeeProdHost ? HUBEE_PROD_API_URL : apiHubeeUrl}
            onChange={onChange}
          />
          <Form.Input
            width={5}
            disabled={isHubeeProdHost || !apiHubeeLiaisonActive}
            name="apiHubeeVersion"
            data-testid="hubee-tab-api-version"
            label="Version API"
            value={isHubeeProdHost ? HUBEE_PROD_API_VERSION : apiHubeeVersion}
            onChange={onChange}
          />
        </Form.Group>
        <Form.Input
          width={16}
          disabled={isHubeeProdHost || !apiHubeeLiaisonActive}
          name="apiHubeeToken"
          data-testid="hubee-tab-api-token"
          label="Accès TOKEN (URL)"
          value={isHubeeProdHost ? HUBEE_PROD_TOKEN_URL : apiHubeeToken}
          onChange={onChange}
        />
        <Form.Group widths="equal">
          <Form.Input
            disabled={!apiHubeeLiaisonActive}
            name="apiHubeeLogin"
            data-testid="hubee-tab-api-login"
            label="Utilisateur"
            value={apiHubeeLogin}
            onChange={onChange}
          />
          <Form.Input
            disabled={!apiHubeeLiaisonActive}
            name="apiHubeeMdp"
            input={{ 'data-testid': 'hubee-tab-api-password' }}
            label="Mot de passe"
            value={apiHubeeMdp}
            onChange={onChange}
          />
        </Form.Group>
        {hubeeStatus && !hubeeStatus.serialized && (
          <Dimmer active inverted>
            <div style={{ textAlign: 'center' }}>
              <HubeeStatusMessage
                serialized={hubeeStatus.serialized}
                liaisonActive={hubeeStatus.liaisonActive}
                showPromotionOnly
              />
            </div>
          </Dimmer>
        )}
      </div>
    </TabParametre>
  );
};

export default TabHubee;
